import { makeStyles } from '@material-ui/core/styles';
import theme from '../../theme';

const useStyles = makeStyles(() => ({
  fetchingData: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 'auto',
    marginBottom: 'auto',
    alignItems: 'center',
  },
  viewAll: {
    float: 'right',
  },
  container: {
    padding: 20,
  },
  vSpacer: {
    margin: '30px 0',
  },
  pickerWrapper: {
    position: 'relative',
    margin: '10px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '10px 5px',
      width: 'calc(50% - 10px)',
    },
    '& > svg': {
      position: 'absolute',
      right: 5,
      top: 6,
      pointerEvents: 'none',
    },
    '& > .MuiFormControl-root > .MuiInputBase-root > .MuiInputBase-input': {
      padding: '10px 15px',
    },
    '& > .MuiFormControl-root': {
      width: '100%',
    },
  },
  name: {
    fontSize: 20,
    color: '#58595B',
    margin: 0,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      minHeight: 0,
    },
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },
  dateCard: {
    width: '100%',
    marginTop: 10,
    '&>div': {
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      '& .MuiInputBase-root ': {
        margin: 10,
      },
      '& .MuiFormLabel-root': {
        top: 10,
        left: 10,
      },
    },
  },
  infoCard: {
    width: '10%',
  },
  center: {
    textAlign: 'center',
    maxWidth: '100%',
  },
  full: {
    width: '100%',
  },
  topLogo: {
    textAlign: 'center',
    height: 75,
    width: 75,
    marginTop: -37.5,
  },
  paragraph: {
    fontFamily: 'Roboto Condensed',
    fontSize: 18,
    lineHeight: '25.5px',
    letterSpacing: '1%',
    color: '#4D4D4F',
    fontWeight: 300,
  },
  heading: {
    fontSize: 45,
    color: '#00B5E2',
    margin: 0,
    marginTop: 15,
    fontFamily: 'Playfair Display',
  },
  bigText: {
    fontSize: 45,
    color: '#00B5E2',
    fontWeight: 700,
    fontFamily: 'Roboto',
  },
  social: {
    maxWidth: '100%',
  },
  toolbar: theme.mixins.toolbar,
  lead__flex: {
    display: 'flex',
  },
  flex__item: {
    flexGrow: 1,
    margin: 15,
    width: '30%',
  },
  flex__item1: {
    flexGrow: 2,
    margin: 15,
    width: '30%',
  },
  colorPrimary: {
    backgroundColor: '#E5E5E5',
  },
  barColorPrimary: {
    backgroundColor: '#109CF1',
  },
  wrapper: {
    margin: 20,
    [theme.breakpoints.down('sm')]: {
      margin: '0 5px',
    },
  },
  card: {
    padding: 15,
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    [theme.breakpoints.down('sm')]: {
      padding: 5,
      margin: 10,
      marginBottom: 15,
    },
  },
  leadsCount: {
    fontSize: '4rem',
    fontWeight: 700,
    lineHeight: 1,
  },
  card__wrapper: {
    padding: '0 10px',
    alignSelf: 'center',
  },
  table__card: {
    padding: '10px 0',
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    [theme.breakpoints.down('sm')]: {
      margin: 10,
      marginBottom: 15,
    },
  },
  noContentBlock: {
    minHeight: 200,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardActionButton: {
    padding: '15px 0 5px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '14px',
    cursor: 'pointer',
  },
  viewAllText: {
    fontSize: 15,
    userSelect: 'none',
  },
  keywordsEnd: {
    display: 'flex',
    '&>p': {
      alignSelf: 'center',
      width: '80%',
      paddingLeft: 16,
    },
  },
}));

export default useStyles;
